<template>
  <span v-if="hasOtherEmployee && showButton">
    <loader v-if="isLoading" />
    <app-button v-else data-qa="transfer-employee-button" @click="transferQuote">{{
      i18n.t('/TransferQuote/TransferEmployeeButton')
    }}</app-button>
  </span>
</template>

<script>
import quoteOrderService from '@/services/quoteOrderService'
import AppButton from '@/components/generic/presentational/atoms/appButton/AppButton.vue'
import Loader from '@/components/generic/presentational/atoms/loader/Loader.vue'
import StoreConnector from '@/helpers/StoreConnector'

export default {
  components: {
    AppButton,
    Loader,
  },
  props: {
    showButton: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isLoading: false,
      hasOtherEmployee: false,
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
    }
  },
  mounted() {
    StoreConnector.get('quote/employee', (data) => {
      if (data == null) {
        this.hasOtherEmployee = false
      } else {
        this.hasOtherEmployee = data.PonId !== StoreConnector.getOnce('user/userName')
      }
    })
  },
  methods: {
    async transferQuote() {
      this.isLoading = true
      const employeeUserName = StoreConnector.getOnce('user/userName')
      const employeeName = StoreConnector.getOnce('user/name')
      const employeeEmail = StoreConnector.getOnce('user/email')

      await quoteOrderService.transferQuoteEmployee(employeeUserName, employeeName, employeeEmail)

      this.isLoading = false
    },
  },
}
</script>

<style></style>
